import { html, LitElement } from 'lit'

import '../../ui/shared/container-loading/container-loading.js'

import { ConnectionStatus } from '../../../shared/Globals.js'
import { getBrowserSupport } from './web3-browser-support.js'

export default class Web3Mixin extends LitElement {
  static properties = {
    wallets: { type: Object },
    selectedDao: { type: Object },
    selectedAccount: { type: Object },
    browserSupport: { type: Object, state: true },
    providerStatus: { type: Object, state: true },
    w3ConnectionStatus: { type: Object, state: true },
  }

  constructor() {
    super()

    /** @type {UserWallet[]} */
    this.wallets = []
    /** @type {BrowserSupportPolicy} */
    this.browserSupport = getBrowserSupport()
    /** @type {import('lit').TemplateResult} */
    this.providerStatus = null
    /** @type {WalletAccount} */
    this.selectedAccount = window.Globals.selectedAccount
    /** @type {DaoSettings} */
    this.selectedDao = window.Globals.selectedDao
    /** @type {ConnectionStatusOptions} */
    this.w3ConnectionStatus = window.Globals.status

    this.setProviderStatus(
      html`
        <container-loading message="Connecting to wallet"></container-loading>
      `
    )
  }

  onGlobalsUpdate(e) {
    const { status, selectedAccount, selectedDao, wallets } = e.detail
    const { CONNECTING, CONNECTED, FAILED } = ConnectionStatus

    Object.assign(this, {
      selectedAccount,
      selectedDao,
      wallets,
      w3ConnectionStatus: status,
    })

    switch (status) {
      case CONNECTING:
        this.setProviderStatus(
          html`
            <container-loading
              message="Connecting to wallets."
            ></container-loading>
          `
        )
        break
      case CONNECTED:
        this.setProviderStatus(null)
        break
      case FAILED:
        this.setProviderStatus(html`<div>Wallet connection error.</div>`)
        break
    }
  }

  /** @param {*} view */
  setProviderStatus(view) {
    this.providerStatus = view

    this.requestUpdate('providerStatus')
  }
}
